<!-- claro-process-intro.component.html -->
<div class="intro-container" [style.--accent]="doc.theme?.accent ?? '#FF6A49'">
    <div class="header" *ngIf="doc?.header">
      <mat-icon *ngIf="doc.header?.icon" class="header__icon">{{ doc.header?.icon }}</mat-icon>
      <h2 *ngIf="doc.header?.title" class="header__title">{{ doc.header?.title }}</h2>
    </div>
  
    <div class="hero" *ngIf="doc?.hero as h">
      <div class="hero__frame" [style.aspect-ratio]="h.aspect || '16/9'">
        <iframe *ngIf="h.type==='video'" class="hero__media"
                [src]="videoUrl" loading="lazy" frameborder="0"
                allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen></iframe>

        <img *ngIf="h.type==='image'" class="hero__media" [src]="h.src" [alt]="h.alt || ''">
      </div>
    </div>
  
    <ng-container *ngFor="let b of doc?.blocks">
      <p class="para" *ngIf="b.type==='paragraph'">{{ b.text }}</p>
  
      <div *ngIf="b.type==='callout'" class="callout" 
           [ngClass]="{
             'callout--warn': b.tone==='warn',
             'callout--info': b.tone==='info',
             'callout--success': b.tone==='success'
           }">
        <span class="callout__text">{{ b.text }}</span>
      </div>
  
      <div *ngIf="b.type==='section-title'" class="section">
        <h3 class="section__title">{{ b.title }}</h3>
        <div class="section__subtitle" *ngIf="b.subtitle">{{ b.subtitle }}</div>
      </div>
  
      <div *ngIf="b.type==='steps'" class="steps">
        <div class="step-card" *ngFor="let s of b.items; let i = index">
          <div class="step-card__badge">{{ i + 1 }}</div>
          <mat-icon *ngIf="s.icon" class="step-card__icon">{{ s.icon }}</mat-icon>
          <div class="step-card__body">
            <div class="step-card__title">{{ s.title }}</div>
            <div class="step-card__subtitle" *ngIf="s.subtitle">{{ s.subtitle }}</div>
          </div>
        </div>
      </div>
  
      <div *ngIf="b.type==='cta'" class="cta">
        <button mat-raised-button class="cta__button" (click)="onAction(b.action)">
            <mat-icon *ngIf="b.icon" class="cta__icon">{{ b.icon }}</mat-icon>
            {{ b.label }}
        </button>
      </div>
    </ng-container>
  </div>
  